import { render, staticRenderFns } from "./ShipInfoPanel.vue?vue&type=template&id=31dff0a2&scoped=true"
import script from "./ShipInfoPanel.vue?vue&type=script&lang=js"
export * from "./ShipInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./ShipInfoPanel.vue?vue&type=style&index=0&id=31dff0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dff0a2",
  null
  
)

export default component.exports